import styled, { css } from 'styled-components'
import { padding, PaddingProps } from 'styled-system'
import themeGet from '@styled-system/theme-get'

import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

type ContainerProps = {
  secondary?: boolean
}

const shouldForwardProp = (prop: string) =>
  ![...DIV_SHOULD_FORWARD_PROP, 'secondary'].includes(prop)

const containerSecondaryCss = ({ secondary }: ContainerProps) =>
  secondary &&
  css`
    background-color: ${themeGet('colors.background.screen')};

    .swiper-button {
      background-color: ${themeGet('colors.background.screen')};
    }
  `

export const Container = styled.div.withConfig({
  shouldForwardProp,
})<ContainerProps>`
  background-color: ${themeGet('colors.background.screenAlt')};
  width: 100%;

  .swiper-button {
    background-color: ${themeGet('colors.background.screenAlt')};
  }

  ${containerSecondaryCss}
`

export const Content = styled.div.withConfig({
  shouldForwardProp,
})<PaddingProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: ${themeGet('space.10')}px;

  ${padding}
`
